// #/app/dashboard/account/connected-accounts/components/ConnectedAccounts.tsx

'use client';

import React, { ReactElement } from 'react';
import Image from 'next/image';
import {
  signIn as signInNextAuth,
  signOut as signOutNextAuth,
} from 'next-auth/react';

// import { FaTwitter } from 'react-icons/fa';

import { Button as UiButton } from '~/ui/button';

interface ConnectedSiteConfig {
  id: string;
  name: string;
  displayName: string;
  logo?: ReactElement<any, any>;
  logoUrl?: string;
  color: string;
  bgColor: string;
}

const ConnectedSites: Record<string, ConnectedSiteConfig> = {
  twitter: {
    id: '1',
    name: 'Twitter',
    displayName: 'Twitter',
    // logo: <FaTwitter />,
    logoUrl: 'https://logo.clearbit.com/twitter.com?size=256',
    color: '#1DA1F2',
    bgColor: '#1374b0',
  },
  // {
  //   id: 2,
  //   name: 'instagram',
  //   displayName: 'Instagram',
  //   logo: <FaInstagram />,
  //   color: '#dd1c68',
  // },
};

function AuthButton({ className = '', text, onClick }) {
  return (
    <div className={`text-primary hover:cursor-pointer ${className}`}>
      {/* <label className="block mb-2">{labelText}</label> */}
      <UiButton size="md" variant="outline" onClick={onClick}>
        {text}
      </UiButton>
    </div>
  );
}

function ConnectedSite(props: {
  config: ConnectedSiteConfig;
  isConnected: boolean;
  connect: (...args: any) => any;
  disconnect: (...args: any) => any;
}) {
  const { config, isConnected, connect, disconnect } = props;
  const { id, name, displayName, logo, logoUrl, color, bgColor } = config;

  function renderConnectButton() {
    return isConnected ? (
      <AuthButton
        className="bg-red-500 rounded-md"
        text="Disconnect"
        onClick={disconnect}
      />
    ) : (
      <AuthButton text="Connect" onClick={connect} />
    );
  }

  // return (
  //   <div
  //     key={id}
  //     className="h-[4rem] flex-row gap-4 sm:w-[30rem] w-[25rem] flex border-[1px] mt-12 rounded-md justify-start"
  //   >
  //     <div className={'text-white text-[50px] flex justify-center p-4'}>
  //       <h1>{logo}</h1>
  //     </div>
  //     <h1 className="text-white pt-4 text-[20px] pb-6">{displayName}</h1>
  //     {isConnected ? (
  //       <h1 className="justify-center cursor-pointer sm:ml-[11rem] p-4 ml-[6rem] ">
  //         {renderConnectButton()}
  //       </h1>
  //     ) : (
  //       <h1 className="justify-center cursor-pointer">
  //         {renderConnectButton()}
  //       </h1>
  //     )}
  //   </div>
  // );

  return (
    <div
      key={id}
      className={`h-[200px] w-[200px] bg-[${bgColor}] rounded-md p-4 flex flex-col items-center justify-center space-y-4`}
    >
      <div
        className={`h-20 w-20 rounded-full bg-[${bgColor}] py-4 flex items-center justify-center text-white text-[50px]`}
      >
        {logo ? (
          logo
        ) : logoUrl ? (
          <Image
            className="rounded-full"
            height={240}
            width={240}
            src={logoUrl}
            alt={displayName}
          />
        ) : null}
      </div>
      <h1 className="text-white text-[20px]">{displayName}</h1>
      {renderConnectButton()}
    </div>
  );
}

function isProviderConnected({ providerKey, connectedProviders }): boolean {
  return connectedProviders.includes(providerKey);
}

export function ConnectedAccounts({ user }) {
  const connectedProviders = user?.connectedProviders ?? [];
  return (
    <>
      {Object.entries(ConnectedSites).map(([providerKey, providerConfig]) => (
        <ConnectedSite
          key={providerKey}
          config={providerConfig}
          isConnected={isProviderConnected({
            providerKey,
            connectedProviders,
          })}
          connect={signInNextAuth}
          disconnect={signOutNextAuth}
        />
      ))}
    </>
  );
}
